<template>
  <div class="wrapp-slider-card">
    <div class="navigation-card-btn-wrapper">
      <div @click="navigate('left')" class="btn-card-slide">
        <img
          src="@/assets/newImges/icons/sliderBtnLeft.svg"
          alt="slider btn left"
        />
      </div>
      <div @click="navigate('right')" class="btn-card-slide">
        <img
          src="@/assets/newImges/icons/sliderBtnRight.svg"
          alt="slider btn right"
        />
      </div>
    </div>

    <div class="slider-card" ref="sliderWrapper">
      <div
        v-for="(card, index) in categories"
        :key="index"
        class="card"
        @click="goTo(card.grp_id)"
      >
        <Icon :icon="card.grp_icon" class="icon" />
        <div class="txt">{{ card.grp_name }}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { Icon } from "@iconify/vue2";
import { api } from "../../api";
export default {
  name: "wrappCard",
  components: {
    Icon
  },
  data() {
    return {
      categories: []
    };
  },
  mounted() {
    this.getGroups();
  },
  methods: {
    getGroups() {
      api
        .getGroups()
        .then(res => {
          console.log(res.data.data);
          this.categories = res.data.data;
        })
        .catch(e => {
          console.log(e);
        });
    },
    navigate(direction) {
      let el = this.$refs.sliderWrapper;
      let itemWidth = 214;
      let itemsShown = Math.ceil(el.clientWidth / itemWidth);
      if (direction === "right") {
        el.scrollLeft += itemWidth * (itemsShown - 1);
      } else {
        el.scrollLeft -= itemWidth * (itemsShown - 1);
      }
    },
    goTo(e) {
      this.$emit("goTo", e);
    }
  },
  watch: {}
};
</script>
<style lang="scss">
.wrapp-slider-card {
  position: relative;
}
.navigation-card-btn-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  .btn-card-slide {
    background: $gray-100;
    border: 1px solid $gray-blue-700;
    box-shadow: 0px 1px 3px #0000000f;
    border-radius: 5px;
    height: fit-content;
    padding: 5px 10px;
    margin-left: 5px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.slider-card {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  overflow: auto;
  scroll-behavior: smooth;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none;

  height: 114px;
  //   background-color: antiquewhite;
  margin-top: 5px;
}
.slider-card::-webkit-scrollbar {
  display: none;
}
.card {
  box-sizing: border-box;
  padding: 5px 10px;
  width: 223px !important;
  min-width: 223px !important;
  // width: calc(25% - 20px);
  height: 100%;
  background-color: $gray-100;
  border: 1px solid $gray-blue-500;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-right: 30px;
  cursor: pointer;

  .txt {
    margin-top: 9px;

    font-weight: 500;
    font-style: Medium;
    font-size: 18px;

    line-height: 100%;
    letter-spacing: 0%;
    text-transform: capitalize;
    color: $blue-1000;
    width: 100%;
    // overflow: hidden;
    // white-space: nowrap;
    // text-overflow: ellipsis;
  }
}
.card:last-of-type {
  margin-right: 0;
}
@media only screen and (max-width: 900px) {
  .slider-card {
    height: 100px;
  }
  .card {
    width: 200px !important;
    min-width: 200px !important;
    .txt {
      margin-top: 9px;

      font-weight: 500;
      font-style: Medium;
      font-size: 16px;

      // overflow: hidden;
      // white-space: nowrap;
      // text-overflow: ellipsis;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
@media only screen and (max-width: 768px) {
  // .slider-card {
  //   display: flex;
  //   flex-direction: row;
  //   flex-wrap: wrap;

  //   height: fit-content;
  //   margin-top: 10px;
  // }
  // .slider-card::-webkit-scrollbar {
  //   display: none;
  // }
  // .card {
  //   margin-top: 20px;
  //   box-sizing: border-box;
  //   padding: 5px 5px;
  //   //   width: 223px;
  //   width: calc(50% - 15px);

  //   height: fit-content;
  //   min-height: 100px;

  //   // .txt {
  //   // margin-top: 9px;

  //   // font-weight: 500;
  //   // font-style: Medium;
  //   // font-size: 18px;

  //   // line-height: 100%;
  //   // letter-spacing: 0%;
  //   // text-transform: capitalize;
  //   // color: $blue-1000;
  //   // width: 100%;
  //   // }
  // }
  // .card:nth-child(even) {
  //   margin-right: 0;
  // }
}
</style>
